import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import CropperPage from './pages/CropperPage';
import EditorPage from './pages/EditorPage';
import StandaloneMemeBuilder from './pages/StandaloneMemeBuilder';
import './styles/globals.css';

// Expand Telegram Mini App to full height
if (window.Telegram?.WebApp) {
  window.Telegram.WebApp.expand();
  window.Telegram.WebApp.ready();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/cropper" element={<CropperPage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/meme-builder" element={<StandaloneMemeBuilder />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
